import React, { useState, useEffect } from "react";
import Iconify from "../../components/Iconify";
import {
  Button,
  Typography,
  Box,
  Chip,
  Stack,
  Avatar,
  Tooltip,
} from "@mui/material";
import CustomTable from "../../components/customTable/CustomTable";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import StatusChip from "../../theme/chip";
import DeleteConfirmation from "../../components/DeleteConfirmation";
import { useNavigate } from "react-router-dom";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import moment from "moment";
import { formatNumber, show_proper_words } from "../../utils/constant";

const TransactionsListProfile = ({
  transaction,
  page,
  setPage,
  rowsPerPage,
  totalPages,
  pageCount,
  totalCount,
  setRowsPerPage,
  setTotalCount,
  setTotalPages,
  setPageCount,
}) => {
  const { setnavbarTitle } = useAdminContext();
  const { enqueueSnackbar } = useSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const [rowDataID, setRowDataID] = useState("");
  const [rowData, setRowData] = useState({});
  const [openDelete, setOpenDelete] = useState(false);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [isInvestigator, setIsInvestigator] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const User_Table_Head = [
    {
      id: "number",
      label: "#",
      type: "number",
    },
    // {
    //   id: "name",
    //   label: "User",
    //   renderData: (row) => (
    //     <span>
    //       {row.name} {" ("}
    //       {row.email}
    //       {")"}
    //     </span>
    //   ),
    // },
    {
      id: "amount",
      label: "Amount",
      renderData: (row) => {
        return <span>${formatNumber(row?.amount)}</span>;
      },
    },
    // {
    //   id: "transaction_type",
    //   label: "Transaction Type",
    // },
    {
      id: "transaction_date",
      label: "Transaction Date",
      renderData: (row) => (
        <span>{moment(row?.date_time).format("DD MMMM YY hh:mm A")}</span>
      ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip status={show_proper_words(row.status)} />
      ),
    },
  ];

  const User_Table_Menu_Options = [
    // {
    //   label: "Edit",
    //   color: "#6d00fc",
    //   icon: "ant-design:edit",
    //   handleClick: handleClickEdit,
    // },
    // {
    //   label: "Delete",
    //   icon: "ant-design:delete-twotone",
    //   color: "red",
    //   handleClick: (row) => {
    //     navigate(`/user-management/edit-user/${row.id}`);
    //   },
    // },
  ];

  useEffect(() => {
    setnavbarTitle("User Management");
  }, []);

  return (
    <div className="">
      <CustomTable
        data={transaction || []}
        TABLE_HEAD={User_Table_Head}
        MENU_OPTIONS={User_Table_Menu_Options}
        // custom_search={{
        //   searchText: searchText,
        //   setSearchText: setSearchText,
        //   handleSubmit: searchFunction,
        // }}
        custom_pagination={{
          total_count: totalCount,
          rows_per_page: rowsPerPage,
          page: page,
          handleChangePage: handleChangePage,
          onRowsPerPageChange: handleChangeRowsPerPage,
        }}
        pageCount={pageCount}
        totalPages={totalPages}
        pagePagination={true}
        handleChangePages={handleChangePages}
        is_hide={true}
      />
    </div>
  );
};

export default TransactionsListProfile;
